import {
  IPageableRechargeOnetimeResponse,
  IRechargeOnetime,
  IRechargeOnetimeGetParams,
  ISingleRechargeOnetimeResponse,
} from "@recharge";
import { Logger } from "@nestjs/common";
import axios from "axios";

import { RechargeResourceEndpoint } from "../../RechargeEndpoint";
import { RechargeAccessTokenManager } from "../RechargeAccessTokenManager";

export class RechargeOnetimesClient extends RechargeResourceEndpoint<
ISingleRechargeOnetimeResponse,
IPageableRechargeOnetimeResponse,
IRechargeOnetimeGetParams,
IRechargeOnetime
> {

  public constructor(
    rechargeKeyManager: RechargeAccessTokenManager,
    baseUrl = "https://api.rechargeapps.com",
  ) {
    super(
      axios.create({ baseURL: baseUrl }),
      rechargeKeyManager.getNextAccessToken.bind(rechargeKeyManager),
      "/onetimes",
      new Logger(RechargeOnetimesClient.name),
    );
  }

  protected override singleGetter(t: ISingleRechargeOnetimeResponse): IRechargeOnetime {
    return t.onetime;
  }

  protected override multiGetter(t: IPageableRechargeOnetimeResponse): IRechargeOnetime[] {
    return t.onetimes;
  }

  /** @param rechargeOnetimeIds the IDs of the onetimes to delete
   * @param useSingleAPIKey if set, a single API key will be used to cancel all the onetimes
   * */
  public async deleteOnetimes(
    rechargeOnetimeIds: number[],
    useSingleAPIKey = false,
  ): Promise<PromiseSettledResult<number>[]> {
    const accessToken = useSingleAPIKey ? this.accessTokenGetter() : undefined;
    const requests = rechargeOnetimeIds.map((otId) => this.deleteOnetime(otId, accessToken));
    return Promise.allSettled(requests);
  }

  public async deleteOnetime(
    rechargeOnetimeId: number,
    accessToken?: string,
  ): Promise<number> {
    await this.requestWithRetry<ISingleRechargeOnetimeResponse>(
      {
        url: `${this.resourcePath}/${rechargeOnetimeId}`,
        config: {
          headers: this.getHeaders(accessToken || this.accessTokenGetter()),
          method: "DELETE",
          params: {
            commit: false,
          },
        },
        newKeyOnRetry: true,
        retryGatewayTimeout: true,
        retryConflict: true,
        truncateLongBody: false,
      },
    );
    return rechargeOnetimeId;
  }

}
